// Display helper for tótem identity.
// Tótems are stored with an auto-generated sequential code ("TT-0042"); the UI
// shows the plain number instead ("#0042"). Falls back to the raw value if the
// expected prefix is absent.
export function formatTotemNumber(code: string): string {
  const match = code.match(/TT-(\d+)/i);
  return match ? `#${match[1]}` : code;
}
